import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import _t from '../utils/translate';
import { api } from '../api';
import Spinner from '../components/Spinner';
import formatPrice  from '../utils/formatPrice';

const OrdersForm = ({ user, language }) => {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (user && user.token) {
      setLoading(true);
      console.log("Retrieving orders with token:", user.token);
      
      api.user.getOrders(user.token)
        .then(res => {
          console.log("API Response:", res);
          console.log("Received data:", res.data);
          setOrders(res.data || []);
          setLoading(false);
        })
        .catch(err => {
          console.error('Error loading orders:', err);
          setError(_t('Could not load your orders. Please try again later.', 'account'));
          setLoading(false);
        });
    } else {
      console.log("User not logged in or token missing");
      setError(_t('You must be logged in to view your orders.', 'account'));
      setLoading(false);
    }
  }, [user]);

  if (loading) {
    return <div className="loading">{_t('Loading your orders...', 'account')}</div>;
  }

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  // Console log pour vérifier les données reçues
  console.log("Orders state:", orders);

  if (!orders || orders.length === 0) {
    return <div className="no-orders">{_t('You have no orders yet.', 'account')}</div>;
  }

  return (
    <div className="orders-history">
      <h3>{_t('Your Orders', 'account')}</h3>
      {orders.map(order => (
        <div className="order-item" key={order.id}>
          <div className="order-header">
            <div className="order-number">
              {_t('Order', 'account')} #{order.number || order.id}
            </div>
            <div className="order-date">
              {new Date(order.date_created).toLocaleDateString()}
            </div>
            <div className="order-status">
              {_t('Status', 'account')}: {_t(order.status, 'order_status')}
            </div>
          </div>
          <div className="order-details">
            <div className="order-total">
              <strong>{_t('Total', 'account')}:</strong> {formatPrice(order.total)}
            </div>
            {order.line_items && order.line_items.length > 0 && (
              <div className="order-products">
                <h4>{_t('Products', 'account')}</h4>
                <table>
                  <thead>
                    <tr>
                      <th>{_t('Product', 'account')}</th>
                      <th>{_t('Quantity', 'account')}</th>
                      <th>{_t('Price', 'account')}</th>
                    </tr>
                  </thead>
                  <tbody>
                    {order.line_items.map(item => (
                      <tr key={item.id}>
                        <td>{item.name}</td>
                        <td>{item.quantity}</td>
                        <td>{formatPrice(item.total)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
};

OrdersForm.propTypes = {
  user: PropTypes.object,
  language: PropTypes.string
};

const mapStateToProps = state => ({
  user: state.user,
  language: state.ui.language
});

export default connect(mapStateToProps)(OrdersForm);